import React from "react";

const LongTextInput = ({ id, name, addEstate, value, error, disabled, onChange, isHomePage }: any) => {
    return (
        <div>
            {(!isHomePage && !addEstate) &&
              <label htmlFor={id} className="form-label">{name}</label>
            }
            {addEstate &&
                <label htmlFor={id} className="form-label">{name}</label>
            }
            <textarea
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={id}
                name={id}
                rows={3}
                value={value}
                onChange={onChange}
                disabled={disabled}
            ></textarea>
            {error && <div className="text-danger">{error.join(' ')}</div>}
        </div>
    );
};
export default LongTextInput;
